import { Box, Button, Container, Typography } from "@mui/material";

const TRIAL_BOOKING_URL = "https://book.stripe.com/28o3fFfSQ5Vu03S8ww";

export const CTASection = () => (
  <Box
    id="cta"
    sx={{
      width: "100%",
      backgroundColor: "teal.main",
      py: { xs: 10, sm: 14 },
      px: { xs: 3, sm: 6 },
      textAlign: "center",
    }}
  >
    <Container maxWidth="md">
      <Typography
        component="h2"
        variant="h3"
        sx={{
          fontWeight: 900,
          color: "common.white",
          mb: 2,
          lineHeight: 1.15,
          fontSize: { xs: "2rem", sm: "2.8rem" },
        }}
      >
        Ready to jump with us?
      </Typography>
      <Typography
        variant="h6"
        sx={{
          color: "common.white",
          opacity: 0.92,
          mb: 5,
          fontWeight: 400,
          lineHeight: 1.6,
          maxWidth: 540,
          mx: "auto",
        }}
      >
        Try your first class for just 80 DKK. Boots are provided - all you
        need to bring is yourself and a willingness to have fun.
      </Typography>
      <Button
        href={TRIAL_BOOKING_URL}
        variant="contained"
        size="large"
        sx={{
          bgcolor: "primary.main",
          color: "common.white",
          fontWeight: 900,
          fontSize: { xs: 16, sm: 18 },
          px: { xs: 4, sm: 6 },
          py: { xs: 1.8, sm: 2 },
          borderRadius: 2,
          boxShadow: "0 4px 20px rgba(0,0,0,0.25)",
          "&:hover": {
            bgcolor: "primary.dark",
          },
        }}
      >
        Book Trial Class - 80 DKK
      </Button>
    </Container>
  </Box>
);
